import { render, staticRenderFns } from "./ChatSalesWechatDialog.vue?vue&type=template&id=96e32ba0&scoped=true"
import script from "./ChatSalesWechatDialog.vue?vue&type=script&lang=js"
export * from "./ChatSalesWechatDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatSalesWechatDialog.vue?vue&type=style&index=0&id=96e32ba0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e32ba0",
  null
  
)

export default component.exports